import { render, staticRenderFns } from "./AttributionTable.vue?vue&type=template&id=b4b46ac2&scoped=true"
import script from "./AttributionTable.vue?vue&type=script&lang=js"
export * from "./AttributionTable.vue?vue&type=script&lang=js"
import style0 from "./AttributionTable.vue?vue&type=style&index=0&id=b4b46ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b46ac2",
  null
  
)

export default component.exports